export const FILTER_TEMPLATE_SAVE_OPTIONS = {
  saveAsNew: 1,
  overwriteExisting: 2,
  dontSave: 3
} as const;

export type FilterTemplateSaveOptions = (typeof FILTER_TEMPLATE_SAVE_OPTIONS)[keyof typeof FILTER_TEMPLATE_SAVE_OPTIONS];
